module.exports = __webpack_public_path__ + "img/WX_logo.c41886a9.png";